const { navigate, withPrefix } = require('gatsby');

const isExternalLink = (lnk = '') => ['http://', 'https://', 'ftp://'].some((protocol) => lnk.startsWith(protocol));

const normalizeString = (s) => {
  if (s) {
    return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  return null;
};

const arrayWithEnouthItemsCarrousel = (items, nbmin) => {
  let result = [...items];
  while (result.length < nbmin) {
    result = [
      ...result,
      ...items.map((item) => ({
        ...item,
        id: `${item.id}-copy-${Math.floor(result.length / items.length)}`,
      })),
    ];
  }
  return result;
};

const folderObjecLocaletMap = {
  'event-en': 'events',
  'event-fr': 'evenements',
  'news_item-en': 'news',
  'news_item-fr': 'actualites',
};

const getObjectUrl = (siteURL, slug, type, locale) => {
  if (slug) {
    const folderKey = `${type}-${locale}`;
    const uri = `/${siteURL}/${folderObjecLocaletMap[folderKey]}/${slug}`;
    return uri.replace(/\/\/+/g, '/');
  }
  return null;
};

const followLink = (url, target) => {
  if (isExternalLink(url) || target === '_blank') {
    typeof target !== 'undefined' && window !== 'undefined' && window.open(toExternalUrl(url), target);
  } else {
    navigate(url);
  }
};

const removeStyleTags = (richText) => {
  // Supprime toutes les balises <style>
  richText = richText.replace(/<style.*?<\/style>/g, '');

  // Supprime les attributs de style des autres balises
  richText = richText.replace(/ style=".*?"/g, '');

  return richText;
};

const dompurifyConfig = {
  ADD_TAGS: ['iframe', 'script', 'more'], //or ALLOWED_TAGS
  ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'target', 'async'], //or //or ALLOWED_ATR
};

const isServer = () => {
  return !(typeof window !== 'undefined' && window.document);
};

const toExternalUrl = (uri, useWithGatsbyLink = false) => {
  if (!uri) return uri;
  if (isExternalLink(uri)) {
    return uri;
  }
  if (useWithGatsbyLink) {
    return uri;
  }
  const wp = withPrefix('/');
  if (uri.startsWith(wp)) {
    return uri;
  }
  return withPrefix(uri);
};

const specialTypeFolders = {
  'news-fr': 'actualites',
  'news-en': 'news',
  'event-fr': 'evenements',
  'event-en': 'events',
};

const createUrl = (slug, locale, websiteUrl, type) => {
  const stk = [websiteUrl];
  if ([''].includes(websiteUrl)) {
    stk.splice(0, 0, '/');
  }
  stk.push(specialTypeFolders[`${type}-${locale}`], slug);
  return stk.join('/').replace(/\/\/+/g, '/');
};

const setupi18n = (locale, i18n) => {
  if (locale !== i18n.language) {
    i18n.changeLanguage(locale);
  }
};

const processFootnotesInText = (htmlContent, footnotes) => {
  const fnRegex = /<fn[^>]*data-id="([^"]*)"[^>]*>(.*?)<\/fn>/gi;
  let match;

  while ((match = fnRegex.exec(htmlContent)) !== null) {
    footnotes.push({
      id: match[1],
      content: match[2],
      originalTag: match[0],
    });
  }

  footnotes.forEach((footnote, index) => {
    const noteIndex = index + 1;
    const placeholder =
      `<span data-footnote-id="${footnote.id}" ` +
      `data-footnote-index="${noteIndex}" data-footnote-placeholder="true">[${noteIndex}]</span>`;
    htmlContent = htmlContent.replace(footnote.originalTag, placeholder);
  });

  return htmlContent;
};

const extractAndProcessFootnotes = (content) => {
  const footnotes = [];

  const processContent = (contentArray) => {
    return Array.isArray(contentArray) ? contentArray.map((contentEl) => {
      if (contentEl.__typename === 'CmsPortalComponentContentText') {
        const processedText = processFootnotesInText(contentEl.text || '', footnotes);
        return {
          ...contentEl,
          text: processedText,
        };
      }

      if (contentEl.__typename === 'CmsPortalComponentContentTextShared') {
        const tsh = contentEl.content_shared?.text_shared;
        if (tsh && tsh.length > 0) {
          const tshe = tsh[0];
          const processedText = processFootnotesInText(tshe.text || '', footnotes);
          return {
            ...contentEl,
            content_shared: {
              ...contentEl.content_shared,
              text_shared: [
                {
                  ...tshe,
                  text: processedText,
                },
              ],
            },
          };
        }
      }

      if (contentEl.content) {
        return {
          ...contentEl,
          content: processContent(contentEl.content),
        };
      }

      return contentEl;
    }) : undefined;
  };

  const processedContent = processContent(content);
  return { footnotes, processedContent };
};

module.exports = {
  isExternalLink,
  followLink,
  removeStyleTags,
  dompurifyConfig,
  arrayWithEnouthItemsCarrousel,
  toExternalUrl,
  isServer,
  getObjectUrl,
  normalizeString,
  setupi18n,
  extractAndProcessFootnotes,
};
